const FinanceDirectorApproval = "Finance Director Approval",
    FinancialSystemsDirectorApproval = "Financial Systems Director Approval",
    PendingCompletionStates = "Completion",
    Final = "Completed",
    Rejected = "Rejected"

const AllStates = [
    FinanceDirectorApproval,
    FinancialSystemsDirectorApproval,
    Final,
    Rejected
]

const PendingRequestStates = [
    FinanceDirectorApproval,
    FinancialSystemsDirectorApproval
]

export { FinanceDirectorApproval, FinancialSystemsDirectorApproval, Final, AllStates, PendingCompletionStates, PendingRequestStates, Rejected };